import { createRoot } from 'react-dom/client';
import type { JSX } from 'react';

export const renderReactRoot = (
  rootJsxElement: JSX.Element,
  rootNodeId: string,
) => {
  const rootNode = document.getElementById(rootNodeId);

  if (!rootNode) {
    throw new Error(`Cannot find <div id="${rootNodeId}">`);
  }

  const root = createRoot(rootNode);
  root.render(rootJsxElement);
};
